<template>
  <div class="mu-grid" id="result">
    <div class="mu-grid__main">
      <div :class="`masonrygrid mu-grid__row mu-grid__row--cols-${this.numColumns}`">
        <div v-for="(card, index) in cards" :key="index" :class="gridItemClasses(card)">
          <!-- <p style="background:red;">{{ card.title }} ## {{ card.cats }}</p> -->
          <card24251
            :card="card"
            :subClasses="card.subClasses"
            :title="card.title"
            :image="card.image"
            :desc="card.desc"
            :cats="card.cats"
            :link="card.link"
            :cta="card.cta"
            :types="types"
            :interval="$data.x"
            :number="$data.n"
            :tags="card.tags ? card.tags : null"
            :attRequired="card.attRequired ? true : false"
            v-on:show-warning-modal="activateWarningModal"
          /><!--Old methods for showing cards:-->
          <!--:load="log()"-->
          <!-- v-show="cards.isActive"-->
          <!--v-if="index <= lazyThreshold[x] && filters[0] == undefined || x > 3 || card.cats.themes.some(item => filters.includes(item))|| card.cats.types.some(item => types.includes(item))"-->
        </div>
        <div class="loading-element"><span></span><div class="see-more"><button class="button-hidden" v-on:focus="seeMore">See More</button><div class="alert"></div></div><loadingAnimation/></div>
        <div class="grid-sizer"></div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import Card24251 from './Card24251.vue';
import loadingAnimation from './loadingAnimation.vue';
import Masonry from '../../node_modules/masonry-layout/dist/masonry.pkgd.min.js';

export default {
  props: {
    cards: { type: Array, required: true },
    filters: { type: Array },
    types: { type: Array }
  },
  components: {
    Card24251,
    loadingAnimation
  },
  data() {
    return {
      numColumns: 3,
      //theme: '',
      loading: false,
      lazyLoad: true,
      lazyThreshold: [],
      x: 0, // Reference to current lazyload threshold
      cardsNoImage: 4, // Sadly, this is not dynamic at the moment.
      msnry: '',
      n: 0,
      currentCard: 0,
      cardsLoaded: false,
      allCardsLoaded: false
    };
  },
  mounted() {
    // Setting up and initializing the masonry layout
    let grid = document.querySelector('.masonrygrid');
    let gridsizer = document.querySelector('.grid-sizer'); // getting a non-masonry grid item to set the column width for the masonry columns before masonry starts
    document.documentElement.style.setProperty('--grid-item-width', gridsizer.offsetWidth + 'px'); // mirroring the column with on the masonry objects with a variable
    this.msnry = new Masonry(grid, {
      itemSelector: '.mu-grid-item',
      columnWidth: '.grid-sizer',
      fitWidth: true,
      gutter: 56,
      transitionDuration: '0.8s', 
    });

    // Updating the masonry layout if the number of cards changes.
    function resizemasonry() { 
      document.documentElement.style.setProperty('--grid-item-width', gridsizer.offsetWidth + 'px');
      thisData.msnry.reloadItems();
      thisData.msnry.layout();
      var cols = thisData.msnry.colYs;
      colHeight = (Math.max(...cols));
      var hiddencards = document.getElementsByClassName('card24251');
      // Turning all the cards solid at once, so they don't load in overtop of one another. 
      for (var i=0; i <= hiddencards.length; i++) { 
          if (hiddencards[i] != undefined) {
            hiddencards[i].style.opacity = 1.0;
          }
          if (i == hiddencards.length && hiddencards.length != 0) {
            moveLoader();
          }
      }
      return colHeight;
      
    }

  // Some extra on top of resizing masonry triggered by resizing the window, so that the loading element is in the right place. 
    function whenresizing() { 
      containerOffset = container.offsetTop - document.querySelector('.mu-grid').offsetTop;;
      resizemasonry(); 
      moveLoader();
      return containerOffset;
    }
    window.onresize = whenresizing;

    var colHeight;
    var numcards = 0;
    var totalCards = this.cards.length;

    // Called when card is created with no image, from Card24251 component.
    this.$root.$on('noImage', () => {
      if (this.types.length != 0) { 
        var hiddencards = document.getElementsByClassName('card24251');
        for (var i=(hiddencards.length - this.cardsNoImage); i <= hiddencards.length; i++) {
            if (hiddencards[i] != undefined) {
              hiddencards[i].style.opacity = 1.0;
            }
        }
      }
    })
    
    // Called every time the card component is used. An $emit from Card24251 component. We reload the masonry and change where the loading element is.
    this.$root.$on('CardsGrid', () => { 
      // If the page is refreshed when there are filters on, this will ensure the masnonry grid runs correctly & the cards are seen.
      if (this.filters[0] != undefined | this.types[0] != undefined){ 
          resizemasonry();
      }
      if (this.x !=0) {
        moveLoader();
        this.loading = false;
        this.loadingElement();
        if (this.x == 3){
          if (this.allCardsLoaded == false) {
            this.endOfCards();
          }
          loadingEl[0].style.display = "none";
          this.loading = false;
          this.loadingElement();
        }
      } 
      if ( numcards < totalCards ) {
        numcards = numcards+1;
      } else {
        numCards = totalCards;
        }

      // Triggered whenever a new lazyload threshold is reached.  
      if (numcards == this.lazyThreshold[this.x] || this.x == 3 && (numcards + this.cardsNoImage) == this.lazyThreshold[this.x] ){
        resizemasonry(); // Does this run too many times? Especially when removing filters... Investigate later.
        // console.log('lazyload threshold', numcards);
        moveLoader();
      } 
      this.lazyLoad = true; 
    })
    
    // Triggered when cards have been given an image.
    this.$root.$on('cardActive', () => {
      if (this.x == 0 && this.currentCard < this.lazyThreshold[this.x]){
        this.currentCard = this.currentCard + 1;
      }
      if (this.x == 0 && this.currentCard == this.lazyThreshold[this.x]){
        resizemasonry();
      }
      if (numcards == this.lazyThreshold[this.lazyThreshold.length -1] - this.cardsNoImage) {
        resizemasonry();
      } 
    })
  
    // Setting the lazy load thresholds at each 25% of the total cards
    var numCards = this.cards.length;
    var lazyArray = [
      Math.round(numCards * 0.25),
      Math.round(numCards * 0.5),
      Math.round(numCards * 0.75),
      Math.round(numCards)
    ];
    this.$set(this.$data,'lazyThreshold', lazyArray);


    var container = document.querySelector('.mu-container');
    var containerOffset = container.offsetTop - document.querySelector('.mu-grid').offsetTop;;
    var loadingEl = document.getElementsByClassName('loading-element'); // Make this query selector
    var loadingElHeight;
    var thisData = this; 
    var lastPosition;
    var refreshRate = 60;
    this.endOfCardsFalse();
    this.isFiltered(thisData);

    // Moving the loading element below the last image (y position)
    function moveLoader() {
      loadingEl[0].style.transform = "translateY(" + colHeight + "px)";
    }

    // To check the scroll to see if we need to load in more cards.
    function replace(){ 
      if(lastPosition != window.scrollY){ // Prevents unnecessary recursion
          lastPosition = window.scrollY; // updates the last position to current
          loadingElHeight = loadingEl[0].offsetHeight;
          if (window.scrollY + loadingElHeight > colHeight + containerOffset && thisData.x <= thisData.lazyThreshold.length && thisData.lazyLoad != false) { // + 100 is buffer...
            thisData.lazyLoad = false;
            thisData.loading = true;
            if (thisData.x != 3) {
              thisData.loadingElement();
            } else {
              resizemasonry();
            }
            // Calling the function that changes the lazyload variable so the rest of the cards load in and the rearranging the masonry layout as needed. 
            // Loading speed varies; this creates a scroll stop and load sequence so the user knows and feels like something is happening and more images are loading.
            var delayInMilliseconds = 500; //Delay to stop user from scrolling while it loads because the system extends the bottom as the cards are loaded in.
              setTimeout(function() {
                thisData.loadItems();
              }, delayInMilliseconds);   
            resizemasonry();
          }
    }}
    function setup(){
        lastPosition = window.scrollY;
        setInterval(replace, 1000 / refreshRate); // 1000 / 60 = 16.666... Invokes function "replace" to update for each frame
    }
    setup();
    this.setActive();
  },

  watch: {
    // Watching for filters. 
    // Load all the cards, so they can be filtered. 
    // Managing the states of the filter reset button.
    types: function (){
      this.gridFilterReset(); // So that activities works without emit from image load, 'cardActive'.
      this.$set(this.$data, 'x', 3);
      if (this.allCardsLoaded == false) {
        this.gridFilterReset();
      }
      var filterresetbutton = document.getElementsByClassName('filter-reset-button'); 
      if (this.filters.length > 0 || this.types.length > 0){
        this.enableButton(filterresetbutton);
      }
      else this.disableButton(filterresetbutton);
    }, 
    filters: function () {
      this.$set(this.$data, 'x', 3);
      if (this.allCardsLoaded == false) {
        this.gridFilterReset();
      }
      var filterresetbutton = document.getElementsByClassName('filter-reset-button'); 
      if (this.filters.length > 0 || this.types.length > 0){
        this.enableButton(filterresetbutton);
      }
      else this.disableButton(filterresetbutton);
    }, 

    // When the lazy load threshold changes, set next cards as active.
    x: function () {
      this.setActive();
    },
  },

  methods: {
    activateWarningModal(data) {
      this.$emit('show-warning-modal', data);
    },
    disableButton(filterresetbutton) {
      let el = filterresetbutton[0]; 
      el.setAttribute('aria-disabled', true);
      el.classList.add('inactive-button'); 
    },
    enableButton(filterresetbutton) {
      let el = filterresetbutton[0]; 
      el.setAttribute('aria-disabled', false);
      el.classList.remove('inactive-button'); 
    },
    endOfCards() {
      var container = document.querySelector('.mu-container');
      container.classList.remove('pad-bottom--10xlg');
    },
    endOfCardsFalse() {
      var container = document.querySelector('.mu-container');
      container.classList.add('pad-bottom--10xlg');
    },
    gridItemClasses(card) {
        const baseClass = 'mu-grid-item';
        const shortNameClass = 'mgi';
        const classes = [];
        classes.push(baseClass);
        classes.push(shortNameClass);
        // Sub classes at the grid item (container) level and not the component (e.g. card).
        if (card.gridSubClasses) {
          card.gridSubClasses.forEach(el => classes.push(el));
        }
        return classes.join(' ');
    },
    loadingElement(){
      document.documentElement.setAttribute('data-loading', this.loading);
    },
    loadItems() {
      if (this.x < 3 && this.loading == true) { 
        this.$set(this.$data,'x', this.x + 1);
      } 
    },

    // Creating a new masonry layout whenever filters are reset.
    gridFilterReset(){
      var thisData = this;
      let grid = document.querySelector('.masonrygrid');
      this.isFiltered(thisData);
      thisData.msnry.destroy();
      thisData.msnry = new Masonry(grid, {  
        itemSelector: '.mu-grid-item',
        columnWidth: '.grid-sizer',
        fitWidth: true,
        gutter: 56,
        transitionDuration: '0.8s',
      });
      var delayInMilliseconds = 0; //To send to back of the thread... Probably a better way to do this
          setTimeout(function() {
          thisData.msnry.reloadItems();
          thisData.msnry.layout();
          }, delayInMilliseconds);
    }, 

    // Managing filter dependant items.
    isFiltered(thisData){
      var filterresetbutton = document.getElementsByClassName('filter-reset-button'); 
      var loadingEl = document.getElementsByClassName('loading-element');
      if (thisData.filters.length > 0 || thisData.types.length > 0){
        loadingEl[0].style.display = "none";
        this.enableButton(filterresetbutton);
        this.endOfCards();
      } 
      else {
        this.disableButton(filterresetbutton);
        if (this.x != 3) {
          this.endOfCardsFalse();
          loadingEl[0].style.display = "flex"; // Maybe think about doing a v-if here...? For state of loading button?
        } else if (this.allCardsLoaded == false){
          this.endOfCards();
          this.allCardsLoaded = true; 
          loadingEl[0].style.display = "none";
        }
      }

    },

    // Loads other cards when tabbing instead of relying on scroll. 
    seeMore() {
      var cards = document.getElementsByClassName('card24251__link');
      var last = this.lazyThreshold[this.x]
      var lastCard = cards[last - 1];
      lastCard.focus();
      if (this.x < 3 ) {
        this.x = this.x+1;
      }
    },

    setActive() {
      // Reloads filtered cards on refresh
      if (this.filters.length > 0 && this.cardsLoaded == false || this.types.length > 0 && this.cardsLoaded == false) {
          var result = this.cards.filter(obj => { 
            return obj.isActive === true
          })
          for ( var i=0; i < result.length; i++ )
          {
            // We're getting it to reset the active cards so the masonry runs again AFTER the images load...
            this.$set(result[i], 'isActive', false);
            this.$set(result[i], 'isActive', true);
          }
          this.$set(this.$data, 'cardsLoaded', true);
          this.$set(this.$data, 'x', 3)
          return;
      } else if (this.cardsLoaded == true) {
        return;
      }
      
      // On reaching lazyload thresholds, we load the images for the next group of cards and make them active. 
      var thisData = this;
      var interval = thisData.lazyThreshold[this.x];
      for (var i = 0; i < interval; i++) { 
        thisData.$set(thisData.cards[i],'isActive', true)
        if (thisData.n < interval){
          thisData.n = this.n+1;
        } 
      }
    } 
  },
  
};
</script>